import { createContext } from 'react'

import { CustomerFeedback, CustomerFeedbackFormContextType } from './types'

export const FormContext = createContext<CustomerFeedbackFormContextType>(null)

// TODO: Replace '-1' with '' tech debt. Or make id optional.
export const INIT_FEEDBACK: CustomerFeedback = {
	type: 'CUSTOMER_FEEDBACK',
	form: {
		details: {
			id: '-1',
			incidentDatetime: '',
			jobNumber: '',
			bookingPhoneNumber: '',
			incidentDetails: '',
			attachments: [],
		},
		customer: {
			id: '-1',
			name: '',
			preferredContactType: null, // or your default PreferredContactType
			preferredDatetime: '',
			email: '',
			phoneNumber: '',
		},
	},
}
